module.exports = __webpack_public_path__ + "media/images/mountains_lake-3773ed8f3196bf4f6b99fe36184f4486.jpg";